import React, { useState, useEffect } from "react";
import axios from "axios";
import OBDetailsTable from "./OBDetails";
import { useNavigate } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import { set } from "date-fns";


export default function OBForm() {
  const [distCode, setDistCode] = useState("");
  const [fpsId, setFpsId] = useState("");
  const [districts, setDistricts] = useState([]);
  const [fpsList, setFpsList] = useState([]);
  const [obData, setObData] = useState(null);
  const[commodities,setCommodities]=useState();
  const [loading, setLoading] = useState(false);
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const navigate = useNavigate();

  const monthname = (monthNum) => {
    return new Date(2000, monthNum - 1).toLocaleString('default', { month: 'long' });
  };
   useEffect(() => {
    const fetchCurrentAndLoad = async () => {
      try {
        const [mRes, yRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_URL_HEADER}/Common/currentMonth`),
          axios.get(`${process.env.REACT_APP_URL_HEADER}/Common/currentYear`),
        ]);

        let m = Number(mRes?.data?.month ?? mRes?.data);
        let y = Number(yRes?.data?.year ?? yRes?.data);


        setMonth(String(m));
        setYear(String(y));
      } catch(error) {
        console.error('Error fetching districts:', error);

      }
    };
    fetchCurrentAndLoad();
  }, []);

  const [submittedFpsId, setSubmittedFpsId] = useState("");
  const [submittedMonth, setSubmittedMonth] = useState(month);
  const [submittedMonthName, setSubmittedMonthName] = useState(monthname);
  const [submittedYear, setSubmittedYear] = useState(year);
    const monthInt = parseInt(month, 10);
    const yearInt = parseInt(year, 10);
    

  useEffect(() => {
    setLoading(true);
    axios.get(`${process.env.REACT_APP_URL}/api/ob/districts`)
      .then(res => {
        setDistricts(res.data);
        setLoading(false);
      })
      .catch(err => {
        console.error("Error fetching districts:", err);
        setLoading(false);
      });
  }, []);

  // Fetch FPS list when distCode changes
  useEffect(() => {
    if (distCode) {
      setLoading(true);
      setFpsId(""); // Reset FPS selection when district changes
      axios.get(`${process.env.REACT_APP_URL}/api/ob/fps/${distCode}`)
        .then(res => {
          setFpsList(res.data);
          setLoading(false);
        })
        .catch(err => {
          console.error("Error fetching FPS:", err);
          setLoading(false);
        });
    } else {
      setFpsList([]);
      setFpsId(""); // Reset FPS selection when district is cleared
    }
  }, [distCode]);

  const handleSubmit = () => {
    if (!distCode) {
      alert("Please select District");
      return;
    }
    if (!fpsId) {
      alert("Please select FPS");
      return;
    }
    if (!month || !year) {
      alert("Month and Year are required");
      return;
    }
    setLoading(true);
    axios.post(`${process.env.REACT_APP_URL}/api/ob/details`, { fpsId, month: monthInt, year: yearInt })
      .then(res => {
        setObData(res.data);
        setSubmittedFpsId(fpsId);
        setSubmittedMonth(month);
        setSubmittedMonthName(monthname(monthInt));
        setSubmittedYear(year);
setCommodities(res.data.commodities);
    console.log("commodities",commodities)

        setLoading(false);
      })
      .catch(err => {
        console.error("Error fetching OB details:", err);
        alert("Failed to fetch OB details");
        setLoading(false);
      });
  };

  return (
    <div className="container mx-auto p-4">
      <table align="center" >
        <thead>
          <tr className="tableheader">
            <th colSpan="8" >Opening Balance (OB) Update Form</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td >Month:</td>
            <td >{monthname(monthInt)}</td>
            <td >Year:</td>
            <td >{year}</td>
            <td >District:</td>
            <td >
              <select
                value={distCode}
                onChange={e => setDistCode(e.target.value)}
              >
                <option value="">--Select--</option>
                {districts.map(d => (
                  <option key={d.dist_code} value={d.dist_code}>{d.dist_name_en}</option>
                ))}
              </select>
            </td>
            <td >FPS:</td>
            <td >
              <select
                value={fpsId}
                onChange={e => setFpsId(e.target.value)}
              >
                <option value="">--Select--</option>
                {fpsList.map(f => (
                  <option key={f.fps_id} value={f.fps_id}>{f.fps_id}-{f.del_name}</option>
                ))}
              </select>
            </td>
          </tr>
          <tr align="center">
            <td colSpan="8" >
              <button
                onClick={handleSubmit}
                className="button"
              >
                Submit
              </button>
              <button
                onClick={() => navigate(-1)}
                className="button"
              >
                Back
              </button>
            </td>
          </tr>
        </tbody>
      </table>
              <br></br>
        <br></br>
      {loading && (
        <div className="text-center">
          <CircularProgress/>

        </div>
      )}

      {obData && (
        <OBDetailsTable
          data={obData}
          month={submittedMonth}
          monthInt={monthInt}
          year={submittedYear}
          fpsId={submittedFpsId}
          distName={obData.dist_name}
          officeName={obData.office_name}
          commodities={commodities}
        />
      )}

    </div>
  );
}
